export default __webpack_public_path__ + "static/media/restraining.a22d635c.png";